import i18n from '@/js/vue-i18n';
import { toSentenceCase } from '../utils/string-utils';

const maxLength = (value, message, length = 100) =>
    !value ||
    value.length <= length ||
    (message || toSentenceCase(i18n.t('validation.common.maxLength', { length })));

export default maxLength;
